<div class="row" data-testid="users-div">
    <div class="col-md-12">
        <div class="panel panel-danger ">
            <div class="panel-heading clearfix">
                <h4 class="panel-title pull-left" style="padding-top: 7.5px;padding-right: 7.5px;">Users</h4>
                <div class="input-group">
                    <span style="padding-top: 7.5px;padding-left: 200px;padding-right: 7.5px;" data-testid="user-count-display">{{totalCount}} Users found</span>
                    <form name="userSearchForm" [formGroup]="userSearchForm">
                        <input id="inputSearchMembers" type="search" formControlName="filter" class="form-control shortInputSearch" placeholder="Filter.." data-testid="user-search-box">
                        <div class="input-group-btn">
                            <button class="btn btn-primary" (click)="search();" data-testid="user-search-button"><i class="glyphicon glyphicon-search"></i></button>
                            <button class="btn btn-primary" (click)="clearSearch();" data-testid="user-clear-search-button"><i class="glyphicon glyphicon-remove-sign"></i></button>
                        </div>
                    </form>
                </div>
            </div>
            <div class="table-responsive" ng-if="!loadingUsers">
                <table class="table table-bordered">
                    <thead>
                        <tr>
                            <th>User Name</th>
                            <th>Email</th>
                            <th>Roles</th>
                            <th>Date Created</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let user of filteredUsers">
                            <td [attr.data-testid]="'user-table-username-' + user.ID">{{user.ID}}  -   {{user.Username}}</td>
                            <td [attr.data-testid]="'user-table-email-' + user.ID">{{user?.Email}}</td>
                            <td [attr.data-testid]="'user-table-roles-' + user.ID">{{user?.Roles}}</td>
                            <td [attr.data-testid]="'user-table-date-created-' + user.ID">{{user?.DateCreated  | date:'MM/dd/yyyy' }}</td>
                            <td><button type="button" (click)="deleteUserClicked(user.ID);" class="btn btn-sm btn-primary" [attr.data-testid]="'user-table-delete-button-' + user.ID">Delete User<i class="fa fa-user-times pull-left"></i></button></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div *ngIf="loadingUsers">
                <div class="col-xs-4"></div>
                <div class="col-xs-4">
                    <i class="fa fa-refresh fa-4x fa-spin"></i> <span class="label label-primary">Loading users...</span>
                </div>
                <div class="col-xs-4"></div>
            </div>
        </div>
    </div>
</div>
